export default "__VITE_ASSET__CsjUY1RL__"